import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "components/Common/ChartsDynamicColor";

const ChartApex = ({ dataColors, chartData, filterType }) => {
  const apaexlineChartColors = getChartColorsArray(dataColors);
  let totalCreated = 0;
  let totalConvert = 0;
  let totalFail = 0;
  const { series, categories, totals } = useMemo(() => {
    const created = [];
    const convert = [];
    const fail = [];
    const categoryLabels = [];

    if (Array.isArray(chartData)) {
      chartData.forEach(item => {
        const day = item?.YearMonthDay?.toString?.() || "";
        categoryLabels.push(day);
        const c = item?.Status1 ?? 0;
        const v = item?.Status2 ?? 0;
        const f = item?.Status3 ?? 0;

        created.push(c);
        convert.push(v);
        fail.push(f);

        totalCreated += c;
        totalConvert += v;
        totalFail += f;
      });
    }

    return {
      categories: categoryLabels,
      series: [
        { name: `Created`, data: created },
        { name: `Convert`, data: convert },
        { name: `Fail`, data: fail },
      ],
      totals: {
        totalCreated,
        totalConvert,
        totalFail,
      }
    };
  }, [chartData]);

  const options = {
    chart: {
      height: 380,
      type: 'line',
      zoom: { enabled: false },
      toolbar: { show: false }
    },
    colors: apaexlineChartColors,
    dataLabels: { enabled: false },
    stroke: { width: [3, 3], curve: 'straight' },
    title: {
      text: 'Unbill Rent Status Chart Report',
      align: 'left',
      style: { fontWeight: '500' },
    },
    grid: {
      row: { colors: ['transparent', 'transparent'], opacity: 0.2 },
      borderColor: '#f1f1f1'
    },
    markers: { style: 'inverted', size: 6 },
    xaxis: {
      categories: categories,
      title: { text: filterType }
    },
    yaxis: {
      title: { text: 'Count' },
      min: 0
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5
    },
    responsive: [{
      breakpoint: 600,
      options: {
        chart: { toolbar: { show: false } },
        legend: { show: false }
      }
    }]
  };

  return (
    <>
      <div className="" style={{ display: "flex", justifyContent: "end", gap: "20px" }}>
        <span><strong>Total Created:</strong> {totalCreated}</span>
        <span><strong>Total Convert:</strong> {totalConvert}</span>
        <span><strong>Total Fail:</strong> {totalFail}</span>
        <span><strong>Total:</strong> {totalCreated + totalConvert + totalFail}</span>
      </div>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height="380"
        className="apex-charts"
      />
    </>
  );
};

export default ChartApex;
